import { render, staticRenderFns } from "./PopupHeader.vue?vue&type=template&id=6bf546b1&"
import script from "./PopupHeader.vue?vue&type=script&lang=js&"
export * from "./PopupHeader.vue?vue&type=script&lang=js&"
import style0 from "./PopupHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports